import React from "react";
import { object } from "prop-types";
import assetify from "@quintype/framework/assetify";
import { ResponsiveImage, Link } from "@quintype/components";

import DefaultAuthorImage from "../../../../assets/images/default-author-image.png";

import "./contributorImage.m.css";

// eslint-disable-next-line react/prop-types
const ContributorImage = ({ authorDisplayName = "", authorObj, slug, customStyle = false, blurStyle = false }) => {
  const authorImg = authorObj ? authorObj["avatar-s3-key"] || authorObj["avatar-url"] : null;
  const PublicAuthor =
    authorObj.metadata && authorObj.metadata["Public Author"]
      ? authorObj.metadata["Public Author"].toLowerCase()
      : null;

  const customWrapperStyle = customStyle ? "contributor-base-wrapper-custom" : "";
  const blurImageStyle = blurStyle ? "contributor-image-blur contributor-image" : "contributor-image";

  const noAuthorImage = () => {
    if (PublicAuthor === "yes") {
      return (
        <Link href={slug}>
          <img
            styleName={blurImageStyle}
            className="contributor-image"
            src={`${assetify(DefaultAuthorImage)}`}
            alt={authorObj.name}
          />
        </Link>
      );
    }
    return (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={`${assetify(DefaultAuthorImage)}`}
        alt={authorObj.name}
      />
    );
  };

  const s3AuthorImage = () => {
    if (PublicAuthor === "yes") {
      return (
        <Link href={slug}>
          <ResponsiveImage
            slug={authorObj["avatar-s3-key"]}
            metadata={authorObj.metadata || ""}
            aspectRatio={[1, 1]}
            defaultWidth={100}
            widths={[100]}
            imgParams={{ auto: ["format", "compress"] }}
            styleName={blurImageStyle}
            className="contributor-image"
            alt={authorObj.name}
          />
        </Link>
      );
    }
    return (
      <ResponsiveImage
        slug={authorObj["avatar-s3-key"]}
        metadata={authorObj.metadata || ""}
        aspectRatio={[1, 1]}
        defaultWidth={100}
        widths={[100]}
        imgParams={{ auto: ["format", "compress"] }}
        styleName={blurImageStyle}
        className="contributor-image"
        alt={authorObj.name}
      />
    );
  };

  const avatarAuthorImage = () => {
    if (PublicAuthor === "yes") {
      return (
        <Link href={slug}>
          <img
            styleName={blurImageStyle}
            className="contributor-image"
            src={authorObj["avatar-url"]}
            alt={authorObj.name}
          />
        </Link>
      );
    }
    return (
      <img
        styleName={blurImageStyle}
        className="contributor-image"
        src={authorObj["avatar-url"]}
        alt={authorObj.name}
      />
    );
  };

  return (
    <div className="contributor-base-wrapper" styleName={customWrapperStyle}>
      {/* Check for avatar s3 key */}
      {authorDisplayName || !authorImg
        ? noAuthorImage()
        : authorObj["avatar-s3-key"]
        ? s3AuthorImage()
        : avatarAuthorImage()}
    </div>
  );
};

ContributorImage.propTypes = {
  authorObj: object
};

export default ContributorImage;
